// import { useState, useCallback, useEffect } from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import {
//   useEditLeadByIdMutation,
//   useGetLeadByIdQuery,
//   useUploadFilesMutation,
// } from "@/features/api/leadsApi";
// import { Loader2 } from "lucide-react";
// import { Button } from "@/components/ui/button";
// import { toast } from "react-hot-toast";
// import LeadGenerationForm from "./LeadGenerationForm";
// import EnrollmentInfoForm from "./EnrollmentInfoForm";
// import DocumentationForm from "./DocumentationForm";

// const EditLead = () => {
//   const navigate = useNavigate();
//   const { id } = useParams();

//   const [editLeadById, { isLoading: isUpdating, error: updateError }] =
//     useEditLeadByIdMutation();
//   const [uploadFiles, { isLoading: isUploadingFiles, error: uploadError }] =
//     useUploadFilesMutation();

//   const [activeTab, setActiveTab] = useState(0);
//   const [completed, setCompleted] = useState(false);
//   const [formErrors, setFormErrors] = useState({});

//   const { data: leadData, isLoading: isFetchingLead, error: fetchError } =
//     useGetLeadByIdQuery(id, { skip: !id });

//   const tabs = [
//     { key: "leadGeneration", label: "Lead Generation" },
//     { key: "enrollmentInfo", label: "Enrollment Info" },
//     { key: "documentation", label: "Documentation" },
//   ];

//   const [form, setForm] = useState({});

//   // --- Load lead data
//   useEffect(() => {
//     if (leadData) {
//       const normalizedData = {
//         ...leadData,
//         dob: leadData.dob
//           ? new Date(leadData.dob).toISOString().split("T")[0]
//           : "",
//       };
//       setForm(normalizedData);
//     }
//     if (fetchError) {
//       toast.error(
//         "Failed to fetch lead data: " +
//           (fetchError.data?.message || "Unknown error")
//       );
//       navigate("/admin/leads");
//     }
//   }, [leadData, fetchError, navigate]);

//   // --- Persist active tab + form in localStorage
//   useEffect(() => {
//     localStorage.setItem("leadActiveTab", String(activeTab));
//   }, [activeTab]);

//   useEffect(() => {
//     const savedTab = localStorage.getItem("leadActiveTab");
//     if (savedTab !== null) setActiveTab(Number(savedTab));
//   }, []);

//   useEffect(() => {
//     localStorage.setItem("leadFormData", JSON.stringify(form));
//   }, [form]);

//   // --- Error handling
//   useEffect(() => {
//     if (updateError) {
//       const msg =
//         updateError.status === 413
//           ? "Request too large. Please reduce file size or number of uploads."
//           : updateError.status === 500
//           ? "Server error occurred. Please try again later."
//           : `Failed to update lead: ${
//               updateError.data?.message || "Check your input."
//             }`;
//       toast.error(msg);
//     }
//     if (uploadError) {
//       toast.error(
//         `Failed to upload files: ${
//           uploadError?.data?.message || "Unknown error"
//         }`
//       );
//     }
//   }, [updateError, uploadError]);

//   // --- Validation
//   const validateFields = (stage = null) => {
//     const errors = {};
//     const stagesToValidate = stage
//       ? [stage]
//       : ["leadGeneration", "enrollmentInfo", "documentation"];

//     if (stagesToValidate.includes("leadGeneration")) {
//       if (!form.firstName) errors.firstName = "First Name is required";
//       if (!form.lastName) errors.lastName = "Last Name is required";
//       if (!form.gender) errors.gender = "Gender is required";
//       if (!form.email || !/\S+@\S+\.\S+/.test(form.email))
//         errors.email = "Valid Email is required";
//       if (!form.phone || !/^[0-9+\-() ]{7,}$/.test(form.phone))
//         errors.phone = "Valid Phone is required";
//     }

//     if (stagesToValidate.includes("enrollmentInfo")) {
//       if (!form.service) errors.service = "Service is required";
//       if (["studyAbroad", "workpermit", "touristVisa"].includes(form.service)) {
//         if (!form.country) errors.country = "Country is required";
//       }
//       if (
//         ["examBooking", "vouchers", "training"].includes(form.service) &&
//         !form.examType
//       ) {
//         errors.examType = "Exam type is required";
//       }
//       if (!form.location) errors.location = "Location is required";
//       if (!form.status) errors.status = "Status is required";
//     }

//     if (stagesToValidate.includes("documentation")) {
//       if (!form.documentationType)
//         errors.documentationType = "Attachment Type is required";

//       // At least one passport field depending on service
//       if (
//         !form.passport &&
//         !form.passportWorkpermit
//       ) {
//         // errors.passport = "Passport is required";
//       }
//     }

//     setFormErrors(errors);
//     return Object.keys(errors).length === 0;
//   };

//   const handleChange = useCallback((e) => {
//     const { name, value } = e.target;
//     setForm((prev) => ({ ...prev, [name]: value }));
//     setFormErrors((prev) => ({ ...prev, [name]: null }));
//   }, []);

//   const handleSave = async () => {
//     const currentStage = tabs[activeTab].key;
//     if (!validateFields(currentStage)) {
//       toast.error("Please fix the highlighted fields.");
//       return false;
//     }
//     return true;
//   };

//   // --- Final update handler
//   const handleNext = async () => {
//     const saved = await handleSave();
//     if (!saved) return;

//     if (activeTab < tabs.length - 1) {
//       setActiveTab((prev) => prev + 1);
//       return;
//     }

//     if (!validateFields()) {
//       toast.error("Please complete all required fields.");
//       return;
//     }

//     const formData = new FormData();
//     formData.append("stage", "documentation");
//     formData.append("isFinalized", "true");

//     // Upload file-type fields
//     const fileKeys = Object.keys(form).filter(
//       (key) => form[key] instanceof File
//     );

//     for (const key of fileKeys) {
//       try {
//         const uploadResult = await uploadFiles(form[key]).unwrap();
//         formData.append(key, uploadResult.fileUrl || "");
//       } catch (err) {
//         toast.error(`Failed to upload file for ${key}`);
//         return;
//       }
//     }

//     // Append other changed fields
//     Object.keys(form).forEach((key) => {
//       if (!(form[key] instanceof File) && form[key] !== leadData?.[key]) {
//         if (key === "dob" && form[key]) {
//           const date = new Date(form[key]);
//           if (!isNaN(date.getTime())) {
//             formData.append(key, date.toISOString());
//           }
//         } else {
//           formData.append(key, form[key]);
//         }
//       }
//     });

//     try {
//       await editLeadById({ id, data: formData }).unwrap();
//       setCompleted(true);
//       localStorage.removeItem("leadFormData");
//       localStorage.removeItem("leadActiveTab");
//       toast.success("Lead updated successfully!");
//       setTimeout(
//         () =>
//           navigate("/admin/leads", {
//             state: { success: "Lead updated successfully!" },
//           }),
//         1500
//       );
//     } catch (err) {
//       toast.error(`Failed to update lead: ${err?.data?.message || "Unknown"}`);
//     }
//   };

//   const handlePrevious = () => {
//     if (activeTab > 0) setActiveTab((prev) => prev - 1);
//   };

//   const handleTabClick = async (idx) => {
//     if (idx > activeTab) {
//       const saved = await handleSave();
//       if (!saved) return;
//     }
//     setActiveTab(idx);
//   };

//   const renderForm = () => {
//     const props = {
//       form,
//       handleChange,
//       formErrors,
//       isSaving: isUpdating || isUploadingFiles,
//     };
//     switch (tabs[activeTab].key) {
//       case "leadGeneration":
//         return <LeadGenerationForm {...props} />;
//       case "enrollmentInfo":
//         return <EnrollmentInfoForm {...props} />;
//       case "documentation":
//         return <DocumentationForm {...props} />;
//       default:
//         return null;
//     }
//   };

//   if (isFetchingLead) {
//     return (
//       <div className="max-w-4xl mx-auto p-6 bg-white shadow-md rounded-xl min-h-screen text-center">
//         <Loader2 className="inline-block mr-2 h-6 w-6 animate-spin" />
//         Loading lead data...
//       </div>
//     );
//   }

//   const progressPercent = ((activeTab + 1) / tabs.length) * 100;

//   return (
//     <div className="max-w-4xl mx-auto p-6 bg-white shadow-md rounded-xl min-h-screen">
//       <h1 className="text-3xl font-bold text-center mb-4">Edit Lead</h1>

//       <div className="w-full bg-gray-200 rounded-full h-2.5 mb-6">
//         <div
//           className="bg-blue-600 h-2.5 rounded-full transition-all duration-300"
//           style={{ width: `${progressPercent}%` }}
//         />
//       </div>

//       <div className="flex justify-between mb-4">
//         {tabs.map((tab, idx) => (
//           <div
//             key={tab.key}
//             className={`cursor-pointer px-3 py-1 rounded-full text-sm font-semibold ${
//               idx === activeTab
//                 ? "bg-blue-600 text-white"
//                 : idx <= activeTab
//                 ? "bg-gray-300 text-gray-800 hover:bg-gray-400"
//                 : "bg-gray-200 text-gray-500"
//             }`}
//             onClick={() => handleTabClick(idx)}
//           >
//             {tab.label}
//           </div>
//         ))}
//       </div>

//       <div className="bg-gray-50 rounded-lg p-6 shadow-sm min-h-[300px]">
//         {completed ? (
//           <div className="text-center py-20">
//             <h2 className="text-2xl font-bold mb-4 text-green-600">
//               🎉 Lead successfully updated!
//             </h2>
//             <Button variant="outline" onClick={() => navigate("/admin/leads")}>
//               Go to Leads Dashboard
//             </Button>
//           </div>
//         ) : (
//           <>
//             {formErrors.totalSize && (
//               <p className="text-red-500 text-center mb-4">
//                 {formErrors.totalSize}
//               </p>
//             )}
//             {renderForm()}
//           </>
//         )}
//       </div>

//       {!completed && (
//         <div className="flex justify-between items-center mt-6">
//           {activeTab === 0 ? (
//             <Button
//               variant="outline"
//               disabled={isUpdating || isUploadingFiles}
//               onClick={() => navigate("/admin/leads")}
//             >
//               Back
//             </Button>
//           ) : (
//             <Button
//               variant="outline"
//               disabled={activeTab === 0 || isUpdating || isUploadingFiles}
//               onClick={handlePrevious}
//             >
//               Previous
//             </Button>
//           )}

//           <Button onClick={handleNext} disabled={isUpdating || isUploadingFiles}>
//             {isUpdating || isUploadingFiles ? (
//               <>
//                 <Loader2 className="mr-2 h-4 w-4 animate-spin" />
//                 Saving...
//               </>
//             ) : activeTab === tabs.length - 1 ? (
//               "Update"
//             ) : (
//               "Next"
//             )}
//           </Button>
//         </div>
//       )}
//     </div>
//   );
// };

// export default EditLead;




import { useState, useCallback, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useEditLeadByIdMutation, useGetLeadByIdQuery } from "@/features/api/leadsApi";
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { toast } from "react-hot-toast";
import LeadGenerationForm from "./LeadGenerationForm";
import EnrollmentInfoForm from "./EnrollmentInfoForm";
import DocumentationForm from "./DocumentationForm";

const EditLead = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const [editLeadById, { isLoading: isUpdating, error: updateError }] = useEditLeadByIdMutation();
  const { data: leadData, isLoading: isFetchingLead, error: fetchError } = useGetLeadByIdQuery(id, {
    skip: !id,
  });

  const [activeTab, setActiveTab] = useState(0);
  const [completed, setCompleted] = useState(false);
  const [formErrors, setFormErrors] = useState({});

  const tabs = [
    { key: "leadGeneration", label: "Lead Generation" },
    { key: "enrollmentInfo", label: "Enrollment Info" },
    { key: "documentation", label: "Documentation" },
  ];

   const initialForm = {
    // LeadGenerationForm
    firstName: "",
    middleName: "",
    lastName: "",
    dob: "",
    gender: "",
    email: "",
    address: "",
    phone: "",
    location: "",
    emergencyContactName: "",
    emergencyContactPhone: "",
    emergencyContactRelation: "",
    // EnrollmentInfoForm
    service: "",
    country: "",
    program: "",
    visaRejection: "",
    travelHistory: "",
    examType: "",
    ebd: "",
    anyspecificlocation: "",
    status: "",
    payment: "",
    // DocumentationForm (all fields from tabs)
    // studyAbroad
    passport: "",
    passportPhotograph: "",
    aadhaarCard: "",
    birthCertificate: "",
    cv: "",
    parentsPassport: "",
    itinerary: "",
    visaCopy: "",
    tenthResult: "",
    tenthPassingCertificate: "",
    eleventhResult: "",
    predictableMarksheet: "",
    twelfthResult: "",
    twelfthPassingCertificate: "",
    sop: "",
    coverLetter: "",
    languageExamCertificate: "",
    lorPrincipal: "",
    lorProfessor1: "",
    lorProfessor2: "",
    bachelorsMarksheets: "",
    predictableTranscript: "",
    transcript: "",
    bachelorsProvisional: "",
    bachelorsCertificate: "",
    wes: "",
    internshipWorkExperience: "",
    gap: "",
    bankStatements: "",
    bankManagerCertificate: "",
    itr: "",
    caNetworth: "",
    companyProof: "",
    sponsorDocs: "",
    loanSanctionLetter: "",
    otherDocumentStudyAbroad: "",
    // workpermit
    passportWorkpermit: "",
    passportPhotographWorkpermit: "",
    aadhaarCardWorkpermit: "",
    panCardWorkpermit: "",
    birthCertificateWorkpermit: "",
    cvWorkpermit: "",
    travelHistoryWorkpermit: "",
    itineraryWorkpermit: "",
    visaCopyWorkpermit: "",
    pccWorkpermit: "",
    marriageCertificateWorkpermit: "",
    academicsWorkpermit: "",
    sopWorkpermit: "",
    coverLetterWorkpermit: "",
    languageExamCertificateWorkpermit: "",
    workExperienceWorkpermit: "",
    gapWorkpermit: "",
    nocWorkpermit: "",
    bankStatementWorkpermit: "",
    bankManagerCertificateWorkpermit: "",
    salarySlipWorkpermit: "",
    itrsWorkpermit: "",
    caNetworthWorkpermit: "",
    companyProofWorkpermit: "",
    otherDocumentWorkpermit: "",
    // touristVisa
    passportTourist: "",
    passportPhotographTourist: "",
    aadhaarCardTourist: "",
    birthCertificateTourist: "",
    cvTourist: "",
    travelHistoryTourist: "",
    itineraryTourist: "",
    visaCopyTourist: "",
    marriageCertificateTourist: "",
    academicsTourist: "",
    coverLetterTourist: "",
    workExperienceTourist: "",
    rejectionLetterTourist: "",
    nocTourist: "",
    bankStatementsTourist: "",
    bankManagerCertificateTourist: "",
    salarySlipTourist: "",
    itrsTourist: "",
    caNetworthTourist: "",
    companyDocsTourist: "",
    sponsorDocsTourist: "",
    otherDocumentTourist: "",
    // examBooking
    Govrmentid: "",
    passportExamBooking: "",
  };

  const [form, setForm] = useState(initialForm);

  const fileFieldsByService = {
    studyAbroad: [
      "passport",
      "passportPhotograph",
      "aadhaarCard",
      "birthCertificate",
      "cv",
      "parentsPassport",
      "itinerary",
      "visaCopy",
      "tenthResult",
      "tenthPassingCertificate",
      "eleventhResult",
      "predictableMarksheet",
      "twelfthResult",
      "twelfthPassingCertificate",
      "sop",
      "coverLetter",
      "languageExamCertificate",
      "lorPrincipal",
      "lorProfessor1",
      "lorProfessor2",
      "bachelorsMarksheets",
      "predictableTranscript",
      "transcript",
      "bachelorsProvisional",
      "bachelorsCertificate",
      "wes",
      "internshipWorkExperience",
      "gap",
      "bankStatements",
      "bankManagerCertificate",
      "itr",
      "caNetworth",
      "companyProof",
      "sponsorDocs",
      "loanSanctionLetter",
      "otherDocumentStudyAbroad",
    ],
    workpermit: [
      "passportWorkpermit",
      "passportPhotographWorkpermit",
      "aadhaarCardWorkpermit",
      "panCardWorkpermit",
      "birthCertificateWorkpermit",
      "cvWorkpermit",
      "travelHistory",
      "itineraryWorkpermit",
      "visaCopyWorkpermit",
      "pccWorkpermit",
      "marriageCertificateWorkpermit",
      "academicsWorkpermit",
      "sopWorkpermit",
      "coverLetterWorkpermit",
      "languageExamCertificateWorkpermit",
      "workExperienceWorkpermit",
      "gapWorkpermit",
      "nocWorkpermit",
      "bankStatementWorkpermit",
      "bankManagerCertificateWorkpermit",
      "salarySlipWorkpermit",
      "itrsWorkpermit",
      "caNetworthWorkpermit",
      "companyProofWorkpermit",
      "otherDocumentWorkpermit",
    ],
    touristVisa: [
      "passportTourist",
      "passportPhotographTourist",
      "aadhaarCardTourist",
      "birthCertificateTourist",
      "cvTourist",
      "travelHistoryTourist",
      "itineraryTourist",
      "visaCopyTourist",
      "marriageCertificateTourist",
      "academicsTourist",
      "coverLetterTourist",
      "workExperienceTourist",
      "rejectionLetterTourist",
      "nocTourist",
      "bankStatementsTourist",
      "bankManagerCertificateTourist",
      "salarySlipTourist",
      "itrsTourist",
      "caNetworthTourist",
      "companyDocsTourist",
      "sponsorDocsTourist",
      "otherDocumentTourist",
    ],
    examBooking: ["Govrmentid", "passportExamBooking"],
    training: [],
  };

  const allFileKeys = Array.from(new Set(Object.values(fileFieldsByService).flat()));

  // Load lead data
  useEffect(() => {
    if (leadData) {
      const normalizedData = {
        ...initialForm,
        ...leadData,
        dob: leadData.dob ? new Date(leadData.dob).toISOString().split("T")[0] || "" : "",
      };
      setForm(normalizedData);
    }
    if (fetchError) {
      toast.error(`Failed to fetch lead data: ${fetchError.data?.message || "Unknown error"}`);
      try {
        localStorage.removeItem("leadFormData");
        localStorage.removeItem("leadActiveTab");
      } catch {}
      navigate("/admin/leads");
    }
  }, [leadData, fetchError, navigate]);

  // Persist active tab
  useEffect(() => {
    try {
      localStorage.setItem("leadActiveTab", String(activeTab));
    } catch {}
  }, [activeTab]);

  // Restore active tab
  useEffect(() => {
    try {
      const savedTab = localStorage.getItem("leadActiveTab");
      if (savedTab !== null) setActiveTab(Number(savedTab));
    } catch {}
  }, []);

  // Persist form
  useEffect(() => {
    try {
      localStorage.setItem("leadFormData", JSON.stringify(form));
    } catch {}
  }, [form]);

  // Error handling
  useEffect(() => {
    if (updateError) {
      const msg =
        updateError.status === 413
          ? "Request too large. Please reduce file size or number of uploads."
          : updateError.status === 500
          ? "Server error occurred. Please try again later."
          : `Failed to update lead: ${updateError.data?.message || "Check your input."}`;
      toast.error(msg);
      if (updateError.data?.errors) {
        setFormErrors((prev) => ({ ...prev, ...updateError.data.errors }));
      }
    }
  }, [updateError]);

  // Validation
  const validateFields = useCallback(
    (stage = null) => {
      const errors = {};
      const stagesToValidate = stage ? [stage] : ["leadGeneration", "enrollmentInfo"];

      if (stagesToValidate.includes("leadGeneration")) {
        if (!form.firstName) errors.firstName = "First Name is required";
        if (!form.lastName) errors.lastName = "Last Name is required";
        if (!form.gender) errors.gender = "Gender is required";
        if (!form.email || !/\S+@\S+\.\S+/.test(form.email))
          errors.email = "Valid Email is required";
        if (!form.phone || !/^[0-9+\-() ]{7,}$/.test(form.phone))
          errors.phone = "Valid Phone is required";
        if (!form.location) errors.location = "Location is required";
        if (form.emergencyContactName && !form.emergencyContactPhone)
          errors.emergencyContactPhone = "Emergency Contact Phone is required";
        if (form.emergencyContactPhone && !form.emergencyContactName)
          errors.emergencyContactName = "Emergency Contact Name is required";
        if (form.emergencyContactPhone && !/^[0-9+\-() ]{7,}$/.test(form.emergencyContactPhone))
          errors.emergencyContactPhone = "Valid Emergency Contact Phone is required";
      }

      if (stagesToValidate.includes("enrollmentInfo")) {
        if (!form.service) errors.service = "Service is required";
        if (["studyAbroad", "workpermit", "touristVisa"].includes(form.service)) {
          if (!form.country) errors.country = "Country is required";
          if (!form.status) errors.status = "Status is required";
        }
        if (["examBooking", "training"].includes(form.service) && !form.examType) {
          errors.examType = "Selection is required";
        }
      }

      setFormErrors(errors);
      return Object.keys(errors).length === 0;
    },
    [form]
  );

  const handleChange = useCallback(
    (eOrObj) => {
      const target = eOrObj?.target ? eOrObj.target : eOrObj;
      const { name, value } = target;

      setForm((prev) => {
        const next = { ...prev, [name]: value };
        if (name === "service") {
          const keep = new Set(fileFieldsByService[value] || []);
          allFileKeys.forEach((key) => {
            if (!keep.has(key)) next[key] = "";
          });
          setFormErrors((prevErrors) => {
            const newErrors = { ...prevErrors };
            allFileKeys.forEach((key) => delete newErrors[key]);
          });
        }
        return next;
      });

      setFormErrors((prev) => ({ ...prev, [name]: null }));
    },
    [allFileKeys]
  );

  const handleChildSubmit = useCallback(
    (childFormData) => {
      setForm((prev) => ({ ...prev, ...childFormData }));
      if (activeTab < tabs.length - 1) {
        setActiveTab((prev) => prev + 1);
      } else {
        handleNext();
      }
    },
    [activeTab, tabs.length]
  );

  const handleSave = useCallback(
    async () => {
      const currentStage = tabs[activeTab].key;
      if (currentStage !== "documentation" && !validateFields(currentStage)) {
        toast.error("Please fix the highlighted fields.");
        return false;
      }
      return true;
    },
    [activeTab, tabs, validateFields]
  );

  const handleNext = useCallback(
    async () => {
      const saved = await handleSave();
      if (!saved) return;

      if (activeTab < tabs.length - 1) {
        setActiveTab((prev) => prev + 1);
        return;
      }

      if (!validateFields()) {
        toast.error("Please complete all required fields.");
        return;
      }

      const formData = new FormData();
      formData.append("stage", form.service === "training" ? "enrollmentInfo" : "documentation");
      formData.append("isFinalized", "true");
      if (form.service) {
        formData.append("service", form.service);
        if (form.service !== "training") {
          formData.append("documentationType", form.service);
        }
      }

      Object.keys(initialForm).forEach((key) => {
        const val = form[key];
        if (val !== undefined && val !== null && val !== "") {
          if (key === "dob") {
            try {
              const date = new Date(val);
              if (!isNaN(date.getTime())) formData.append(key, date.toISOString());
              else formData.append(key, val);
            } catch {
              formData.append(key, val);
            }
          } else {
            formData.append(key, val);
          }
        }
      });

      try {
        await editLeadById({ id, data: formData }).unwrap();
        setCompleted(true);
        try {
          localStorage.removeItem("leadFormData");
          localStorage.removeItem("leadActiveTab");
        } catch {}
        toast.success("Lead updated successfully!");
        navigate("/admin/leads", { state: { success: "Lead updated successfully!" } });
      } catch (err) {
        toast.error(`Failed to update lead: ${err?.data?.message || "Unknown error"}`);
      }
    },
    [activeTab, form, id, editLeadById, navigate]
  );

  const handlePrevious = useCallback(() => {
    if (activeTab > 0) setActiveTab((prev) => prev - 1);
  }, [activeTab]);

  const handleTabClick = useCallback(
    async (idx) => {
      if (idx > activeTab) {
        const ok = await handleSave();
        if (!ok) return;
      }
      setActiveTab(idx);
    },
    [activeTab, handleSave]
  );

  const handleBack = useCallback(() => {
    if (Object.values(form).some((val) => val !== initialForm[val] && val !== "")) {
      if (!window.confirm("You have unsaved changes. Are you sure you want to leave?")) {
        return;
      }
    }
    navigate("/admin/leads");
  }, [form, navigate]);

  const renderForm = useCallback(() => {
    const props = {
      form,
      handleChange,
      formErrors,
      isSaving: isUpdating,
      onSubmit: handleChildSubmit,
    };
    switch (tabs[activeTab].key) {
      case "leadGeneration":
        return <LeadGenerationForm {...props} />;
      case "enrollmentInfo":
        return <EnrollmentInfoForm {...props} />;
      case "documentation":
        return <DocumentationForm {...props} />;
      default:
        return null;
    }
  }, [activeTab, form, formErrors, isUpdating, handleChildSubmit]);

  if (isFetchingLead) {
    return (
      <div
        className="max-w-4xl mx-auto p-6 bg-white shadow-md rounded-xl min-h-screen text-center"
        aria-live="polite"
      >
        <Loader2 className="inline-block mr-2 h-6 w-6 animate-spin" />
        Loading lead data...
      </div>
    );
  }

  const progressPercent = ((activeTab + 1) / tabs.length) * 100;

  return (
    <div className="max-w-4xl mx-auto p-6 bg-white shadow-md rounded-xl min-h-screen">
      <h1 className="text-3xl font-bold text-center mb-4">✏️ Edit Lead</h1>

      <div
        className="w-full bg-gray-200 rounded-full h-2.5 mb-6"
        role="progressbar"
        aria-label="Form progress"
        aria-valuenow={progressPercent}
        aria-valuemin="0"
        aria-valuemax="100"
      >
        <div
          className="bg-blue-600 h-2.5 rounded-full transition-all duration-300"
          style={{ width: `${progressPercent}%` }}
        />
      </div>

      <div className="flex justify-between mb-4" role="tablist" aria-label="Form sections">
        {tabs.map((tab, idx) => (
          <button
            key={tab.key}
            role="tab"
            aria-selected={idx === activeTab}
            className={`cursor-pointer px-3 py-1 rounded-full text-sm font-semibold ${
              idx === activeTab
                ? "bg-blue-600 text-white"
                : idx <= activeTab
                ? "bg-gray-300 text-gray-800 hover:bg-gray-400"
                : "bg-gray-200 text-gray-500"
            }`}
            onClick={() => handleTabClick(idx)}
            disabled={isUpdating}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div className="bg-gray-50 rounded-lg p-6 shadow-sm min-h-[300px]">
        {completed ? (
          <div className="text-center py-20" aria-live="polite">
            <h2 className="text-2xl font-bold mb-4 text-green-600">
              🎉 Lead successfully updated!
            </h2>
            <Button variant="outline" onClick={() => navigate("/admin/leads")}>
              Go to Leads Dashboard
            </Button>
          </div>
        ) : (
          renderForm()
        )}
      </div>

      {!completed && (
        <div className="flex justify-between items-center mt-6">
          {activeTab === 0 ? (
            <Button variant="outline" disabled={isUpdating} onClick={handleBack}>
              Back
            </Button>
          ) : (
            <Button
              variant="outline"
              disabled={activeTab === 0 || isUpdating}
              onClick={handlePrevious}
            >
              Previous
            </Button>
          )}

          <Button onClick={handleNext} disabled={isUpdating}>
            {isUpdating ? (
              <>
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                Saving...
              </>
            ) : activeTab === tabs.length - 1 ? (
              "Update"
            ) : (
              "Next"
            )}
          </Button>
        </div>
      )}
    </div>
  );
};

export default EditLead;